import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
  <p>
      <br />
      <strong>Description</strong>
  </p>
  <p>
      This action triggers the bottom 5 pickers with the highest picked package opportunity missed. Where Pick Package Opportunity Missed is equal to (Expected packages touched - Actual packages touched) * Hours. These associate have a
      minimum of 3 hours in path from prior week.&nbsp;
  </p>
  <p><strong>Impact</strong></p>
  <p>
      Pick and Stage is a direct representation of Standard Work Output quantifying the number of completed packages ready for a singular route. By having visibility on the Associates, this will have a direct impact on the number of
      engagements that are conducted on a daily basis, therefore facilitating increased loadout efficiency. This action encourages an L3+ Leader to perform the
      <span className="wikiexternallink">
          <a
              href="https://d26wfe7v40mam2.cloudfront.net/US_EN/Pick_StandardWork/story.html"
              data-toggle="tooltip"
              data-placement="top"
              title=""
              rel="nofollow noreferrer noopener"
              data-original-title="Warning: This is an external link to d26wfe7v40mam2.cloudfront.net"
          >
              Pick Standard Work Coaching
          </a>
      </span>
      with the associate to help direct the seek to understand conversation on any barriers the Associate may be having trying to follow Pick and Stage Standard Work.&nbsp;
  </p>
  <p><strong>Resolution Steps</strong></p>
  <p>
      1) Complete the
      <span className="wikiexternallink">
          <a
              href="https://d26wfe7v40mam2.cloudfront.net/US_EN/Pick_StandardWork/story.html"
              data-toggle="tooltip"
              data-placement="top"
              title=""
              rel="nofollow noreferrer noopener"
              data-original-title="Warning: This is an external link to d26wfe7v40mam2.cloudfront.net"
          >
              Pick Standard Work Coaching
          </a>
      </span>
      .
      <span
          style="
              -webkit-text-stroke-width: 0px;
              color: #212f3e;
              display: inline !important;
              float: none;
              font-family: Ember, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
              font-size: medium;
              font-style: normal;
              font-variant-caps: normal;
              font-variant-ligatures: normal;
              font-weight: 400;
              letter-spacing: normal;
              orphans: 2;
              text-align: start;
              text-decoration-color: initial;
              text-decoration-style: initial;
              text-decoration-thickness: initial;
              text-indent: 0px;
              text-transform: none;
              white-space: pre-wrap;
              widows: 2;
              word-spacing: 0px;
          "
      >
          (hold SHIFT before clicking the link to open in new window)
      </span>
      <br />
      2) After completing the Coaching, come back to the SCC Work Item and click the "Task Complete" Button in the bottom righthand corner of the SCC Work Item.
  </p>
  <p><strong>Supplemental Links</strong></p>
  <p>
      1)
      <span className="wikiexternallink">
          <a
              href="https://d26wfe7v40mam2.cloudfront.net/US_EN/Pick_StandardWork/story.html"
              data-toggle="tooltip"
              data-placement="top"
              title=""
              rel="nofollow noreferrer noopener"
              data-original-title="Warning: This is an external link to d26wfe7v40mam2.cloudfront.net"
          >
              Pick Standard Work Coaching
          </a>
      </span>
      <span
          style="
              -webkit-text-stroke-width: 0px;
              color: #212f3e;
              display: inline !important;
              float: none;
              font-family: Ember, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
              font-size: medium;
              font-style: normal;
              font-variant-caps: normal;
              font-variant-ligatures: normal;
              font-weight: 400;
              letter-spacing: normal;
              orphans: 2;
              text-align: start;
              text-decoration-color: initial;
              text-decoration-style: initial;
              text-decoration-thickness: initial;
              text-indent: 0px;
              text-transform: none;
              white-space: pre-wrap;
              widows: 2;
              word-spacing: 0px;
          "
      >
          (hold SHIFT before clicking the link to open in new window)
      </span>
      <br />
      2)
      <span className="wikiinternallink">
          <a
              href="https://us-east-1.quicksight.aws.amazon.com/sn/dashboards/3c512f1b-7832-4fe0-8cc9-69f72b8a31d4/sheets/3c512f1b-7832-4fe0-8cc9-69f72b8a31d4_e66b5c8d-8b84-4c83-8e05-4eb1c5a94c07?state=hashArgs%23&amp;isauthcode=true&amp;qs-signin-user-auth=false&amp;directory_alias=amzlbiaquicksight"
          >
              Learning Curve Dashboard
          </a>
      </span>
      <span
          style="
              -webkit-text-stroke-width: 0px;
              color: #212f3e;
              display: inline !important;
              float: none;
              font-family: Ember, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
              font-size: medium;
              font-style: normal;
              font-variant-caps: normal;
              font-variant-ligatures: normal;
              font-weight: 400;
              letter-spacing: normal;
              orphans: 2;
              text-align: start;
              text-decoration-color: initial;
              text-decoration-style: initial;
              text-decoration-thickness: initial;
              text-indent: 0px;
              text-transform: none;
              white-space: pre-wrap;
              widows: 2;
              word-spacing: 0px;
          "
      >
          (hold SHIFT before clicking the link to open in new window)
      </span>
  </p>
</div>
`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Pick_Productivity.jsx